import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=b76b326a&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=ts"
export * from "./StepFour.vue?vue&type=script&lang=ts"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=b76b326a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76b326a",
  null
  
)

export default component.exports